import Config from 'config'

const jsonurl = {
  sms: {
    address: Config.service.api + '/open/sms/url',
    allSendUrl: Config.service.api + '/open/sms/allSendUrl',
    signupCaptchaValidate: Config.service.api + '/open/sms/signup/validate', // 验证注册验证码
    passwordsCaptchaValidate: Config.service.api + '/open/sms/passwords/captcha/validate' // 验证修改密码验证码
  },
  user: {
    rebp: Config.service.api + '/company/info/updateAccountNum',
    login: Config.service.api + '/login', // 登录
    phonelogin: Config.service.api + '/login/mobilePhone/validate', // 手机验证码登陆
    createQrcode: Config.service.api + '/login/createQrcode', // 二维码登录-获取二维码
    getLoginResult: Config.service.api + '/login/getLoginResult', // 二维码登录-获取登录状态
    logout: Config.service.api + '/open/user/logout', // 退出登录
    cas: Config.service.api + '/open/user/authc/info', // cas获取用户信息
    info: Config.service.api + '/user/info/me', // 获取用户信息
    userInfo: Config.service.api + '/user/info', // 修改个人基础信息
    vaildReg: Config.service.api + '/open/general/valid', // 验证手机号是否注册
    register: Config.service.api + '/open/user/register', // 注册
    chpwd: Config.service.api + '/user/info/change/passwords', // 修改密码
    repwd: Config.service.api + '/open/user/resetting/passwords', // 重置密码
    commentList: Config.service.api + '/comment/', // 评论列表
    commen: Config.service.api + '/comment/create', // 创建评论
    bizNo: Config.service.api + '/common/commonauthrealname', // 获取实名认证订单号
    certifyQr: Config.service.api + '/common/commonauthrealname/certify', // 获取实名认证二维码
    identityVerified: Config.service.api + '/user/info/identity/verified', // 用户身份证验证
    leadState: Config.service.api + '/company/info/leadState', // 新手引导步骤完成情况
    updateState: Config.service.api + '/student/info/updateState' // 点击打印按钮调修改状态接口
  },
  collect: {
    favor: Config.service.api + '/common/favor', // 收藏
    favorStatus: Config.service.api + '/common/favor/status', // 是否已经收藏
    favorRecord: Config.service.api + '/student/daily/record/me/favor' // 我的日志收藏列表
  },
  notify: {
    // 通知、消息、评论、订单
    comment: Config.service.api + '/comment', // 评论列表 创建评论
    commentList: Config.service.api + '/comment/me', // 评论列表
    notice: Config.service.api + '/notice', // 我的通知列表
    deleteComment: Config.service.api + '/notice/{id}', // 删除某个通知
    batchDeleteComment: Config.service.api + '/notice?{id}', // 批量删除通知
    newComment: Config.service.api + '/notice/new', // 是否有新消息
    readComment: Config.service.api + '/notice/{id}/read', // 标记某个通知已读
    readCommentBatch: Config.service.api + '/notice/read/batch?{id}', // 标记多个通知已读
    allReadComment: Config.service.api + '/notice/read', // 标记全部通知已读
    myOrder: Config.service.api + '/common/order/my', // 我的订单列表
    myOrderStatistics: Config.service.api + '/common/order/my/statistics', // 我的订单列表统计
    order: Config.service.api + '/common/order', // 统一下单
    closeOrder: Config.service.api + '/common/order/cancel', // 取消订单
    payqrcode: Config.service.api + '/common/order/payqrcode', // 获取二维码
    payStatus: Config.service.api + '/common/order/status', // 获取支付状态
    messageuser: Config.service.api + '/user/message', // 邮件收件箱列表（接收消息）
    noticeUnread: Config.service.api + '/notice/unread/statistics', // 未读消息统计
    messageUnread: Config.service.api + '/user/message/unread/statistics', // 未读邮件统计
    messageuserDetails: Config.service.api + '/user/message/{id}', // 邮件收件箱详情
    messagequeue: Config.service.api + '/message/queue', // 邮件已发送与草稿箱列表
    messagequeueDetails: Config.service.api + '/message/queue/{id}', // 邮件已发送与草稿箱详情
    messagequeueReceiver: Config.service.api + '/message/queue/receiver', // 联系人列表
    messagequeueAdd: Config.service.api + '/message/queue', // 邮件存草稿
    messagequeueSend: Config.service.api + '/message/queue/send', // 邮件发送
    messageuserIdRead: Config.service.api + '/user/message/{id}/read', // 标记邮件已读
    messageuserRead: Config.service.api + '/user/message/read', // 标记全部邮件已读
    messageuserIdDe: Config.service.api + '/user/message/{id}', // 收件箱删除邮件
    messageuserDe: Config.service.api + '/user/message?{id}', // 收件箱批量删除邮件
    messagequeueIdDe: Config.service.api + '/message/queue/{id}', // 已发送与草稿箱删除邮件
    messagequeueDe: Config.service.api + '/message/queue?{id}', // 已发送与草稿箱批量删除邮件
    messageNickname: Config.service.api + '/message/queue/nickname' // 检测收件人是否存在
  },
  tree: {
    source: '/knowledge/tree/info'
  },
  student: {
    give: Config.service.api + '/student/info/give', // 赠送职豆
    quality: Config.service.api + '/student/diathesis/my', // 素质信息
    resume: Config.service.api + '/student/info/resume', // 附件简历
    myexpirePea: Config.service.api + '/student/info/me/expirePea', // 到期职豆记录
    myActiveCoin: Config.service.api + '/student/info/me/activityCoin', // 活动奖励职豆记录
    rechargeList: Config.service.api + '/open/common/recharge/activity', // 充值列表
    myCoin: Config.service.api + '/student/info/me/coin', // 传世币余额
    myCoinRecord: Config.service.api + '/student/transnalCoinLog/my', // 传世币记录
    signedStudent: Config.service.api + '/student/info/signed', // 签约学生
    allStudent: Config.service.api + '/student/info/all', // 全部学生
    examPoint: Config.service.api + '/student/exam/point', // 考点列表
    timeOptional: Config.service.api + '/student/exam/hall/time/interval/optional', // 考试时段
    myLearningMaterial: Config.service.api + '/student/learning/material/me/favor', // 我收藏的学习资料
    positionApplyInfo: Config.service.api + '/student/company/position/{id}/apply', // 岗位申请信息
    professionApplyInfo: Config.service.api + '/student/profession/info/{id}/apply', // 职业申请信息
    userPersonal: Config.service.api + '/student/user/personal/details', // 新增用户履历
    statistics: Config.service.api + '/open/quantity/statistics', // 数量统计
    recordCount: Config.service.api + '/student/daily/record/me/counts', // 日志数量统计
    userPersonalList: Config.service.api + '/student/user/personal/details', // 用户履历列表
    userPersonalDe: Config.service.api + '/student/user/personal/details/{id}', // 用户履历删除
    userPersonalDetail: Config.service.api + '/student/user/personal/details/{id}', // 用户履历详情
    userPersonalUpdate: Config.service.api + '/student/user/personal/details/{id}', // 用户履历修改
    userPersonalCount: Config.service.api + '/student/user/personal/details/count', // 用户履历统计
    newAddQuality: Config.service.api + '/student/diathesis', // 新增用户素质
    modifyQuality: Config.service.api + '/student/diathesis/{id}', // 修改用户素质
    userQualitylDe: Config.service.api + '/student/diathesis/{id}', // 用户素质删除
    userQualitylCount: Config.service.api + '/student/diathesis/count', // 用户素质统计
    knowledge: Config.service.api + '/open/student/knowledge/point', // 用户知识点列表
    myInfo: Config.service.api + '/user/info/me', // 学生个人信息
    meInfo: Config.service.api + '/student/info/me', // 学生个人信息
    myOfferList: Config.service.api + '/student/position/apply/me', // 用户岗位列表
    myOfferListCount: Config.service.api + '/student/position/apply/me/count', // 用户岗位统计
    favoritePosition: Config.service.api + '/student/favorite/position/my', // 收藏岗位列表
    myExpectedPosition: Config.service.api + '/student/expected/position/me', // 用户列表
    myExpectedPositionDelete: Config.service.api + '/student/expected/position/{id}/me', // 删除职业意向
    myExpectedPositionUpdate: Config.service.api + '/student/expected/position/{id}/me', // 用户岗位意向修改
    myExpectedPositionDetail: Config.service.api + '/student/expected/position/{id}', // 职业意向详情
    positionSign: Config.service.api + '/student/position/apply/{id}/sign', // 求职者签协议
    myExpectedPositionCreate: Config.service.api + '/student/expected/position/me', // 用户岗位意向新建
    // myExpectedPositionUpdate: Config.service.api + '/student/expected/position/me', // 用户岗位意向修改
    userPositionDetail: Config.service.api + '/open/student/expected/position/info/{id}', // 用户期望
    myExamList: Config.service.api + '/student/exam/me', // 用户考试列表
    myProctor: Config.service.api + '/student/exam/me/proctor', // 我的监考列表
    query: Config.service.api + '/student/exam', // 监考大厅列表
    startProctor: Config.service.api + '/student/exam/proctor/{id}', // 监考老师开始监考
    grab: Config.service.api + '/student/exam/grab/{id}', // 监考老师抢单
    examPaper: Config.service.api + '/student/exam/start/{id}', // 某个考试的考题列表
    examDetail: Config.service.api + '/student/exam/{id}', // 考试详情
    abandonExam: Config.service.api + '/student/exam/abandon/{id}', // 取消考试
    submitExam: Config.service.api + '/student/exam/end/{id}', // 考试结束提交试卷
    examTest: Config.service.api + '/student/exam/start/test', // 用户测试考题列表
    examPositionTest: Config.service.api + '/student/company/position/{id}/exam', // 岗位测试
    examPositionSubmit: Config.service.api + '/student/company/position/end/{id}', // 岗位测试提交
    offerApply: Config.service.api + '/student/position/apply', // 申请岗位
    // 暂时修改
    userInfo: Config.service.api + '/student/skill/count/{id}', // 用户素质分 [get]
    studentinfo: Config.service.api + '/student/info/{id}', // 用户信息
    studentinfoUpdate: Config.service.api + '/student/info/me/university', // 用户学校信息修改
    myStudent: Config.service.api + '/student/info/counselor/teacher', // 辅导老师的学生列表
    professionList: Config.service.api + '/open/profession/info', // 职业列表
    professionDetail: Config.service.api + '/open/profession/info/{id}', // 职业详情
    PositionList: Config.service.api + '/student/company/position', // 企业岗位列表
    professionCreate: Config.service.api + '/student/profession', // 职业报名
    professionCompany: Config.service.api + '/open/profession/info/{id}/company', // 职业优选企业
    professionStudent: Config.service.api + '/open/student/profession', // 职业报名求职者
    knowledgePoints: Config.service.api + '/student/knowledge/point/all', // 所有知识点
    knowledgePoint: Config.service.api + '/student/knowledge/point', // 知识点
    CounselorCreate: Config.service.api + '/student/counselor', // 知识库新建
    CounselorUpdate: Config.service.api + '/student/counselor/{id}', // 知识库修改
    CounselorDelete: Config.service.api + '/student/counselor/{id}', // 知识库删除
    CounselorFile: Config.service.api + '/student/counselor/file/{id}', // 某个文件夹下文章列表
    CounselorDetail: Config.service.api + '/open/student/counselor/{id}', // 知识库详情
    CounselorList: Config.service.api + '/open/student/counselor', // 知识库列表
    CounselorPackage: Config.service.api + '/student/counselor/package', // 知识库文件列表
    myTaskList: Config.service.api + '/student/task/myTasks', // 用户的任务列表
    taskList: Config.service.api + '/student/task/me', // 我的任务列表
    startTask: Config.service.api + '/student/task/start', // 开始任务
    learingClass: Config.service.api + '/learning/class', // 班级列表
    myClass: Config.service.api + '/learning/class/me', // 我的班级
    mycourseList: '/anchor/course', // 我发布的课程列表
    examCreate: Config.service.api + '/student/exam', // 申请考试
    skillCompleted: Config.service.api + '/student/knowledge/point/difficulty/{id}/status', // 技能点是否完成
    getJsonTree: Config.service.api + '/student/knowledge/tree/info', // 获取技能树
    chapter: Config.service.api + '/student/course/chapter', // 开始章节学习
    finishLearn: Config.service.api + '/student/course/finish', // 完成章节学习
    learnCourse: Config.service.api + '/student/course', // 报名学习课程
    collectCourse: Config.service.api + '/student/course/favor', // 报名学习课程
    courseCount: Config.service.api + '/student/course/statistics', // 求职者课程数量统计
    courseStatus: Config.service.api + '/common/order/status/{id}/{id}', // 课程购买状态
    companyCourse: Config.service.api + '/student/course/company', // 已签约公司的课程
    collectPosition: Config.service.api + '/student/favorite/position', // 收藏岗位
    deleteCollectPosition: Config.service.api + '/student/favorite/position', // 删除收藏的岗位
    collectPositionStatus: Config.service.api + '/student/favorite/position/status', // 是否收藏岗位
    record: Config.service.api + '/position/test/record/{id}'
  },
  journal: {
    list: Config.service.api + '/student/daily/record/me', // 获取我的日志列表
    difficulty: '/open/student/daily/record/difficulty', // 知识点难度值-列表
    studentDailyRecords: Config.service.api + '/student/daily/record', // 所有日志列表
    studentDailyRecord: Config.service.api + '/open/student/daily/record', // 所有日志列表
    delet: Config.service.api + '/student/daily/record/{id}', // 删除日志
    check: Config.service.api + '/open/student/daily/record/{id}', // 查看日志
    appraise: Config.service.api + '/student/daily/record/me/appraise', // 我的评审列表
    appr: Config.service.api + '/student/daily/record/{id}/appraise' // 日志评审
  },
  company: {
    expirationDate: Config.service.api + '/common/order/expirationDate', // 企业剩余时间
    companyPayOrder: Config.service.api + '/common/order/companyPayOrder', // 企业缴费下单
    companyOrder: Config.service.api + '/common/order/companyOrder', // 企业订单
    miniQrcode: Config.service.api + '/company/info/{id}/miniQrcode', // 应聘者二维码
    feedBackContent: Config.service.api + '/sys/minifeedback/feedBackContent', // 获取意见反馈
    minifeedback: Config.service.api + '/sys/minifeedback', // 反馈意见
    totaltime: Config.service.api + '/company/position/{id}/updateLimitTime', // 答题总时间设置
    testRecord: Config.service.api + '/company/position/{id}/testRecord', // 岗位测试详情
    questionBank: Config.service.api + '/company/position/{id}/isOfficial', // 岗位测试详情题库列表
    positionTestList: Config.service.api + '/position/test/record/queryTestCount', // 岗位测试成员列表
    questionBankCreate: Config.service.api + '/knowledge/question/bank/create', // 岗位测试新增题库
    pointKnow: Config.service.api + '/knowledge/point/open/query', // 考题相关知识点列表
    edittopic: Config.service.api + '/knowledge/question/bank/{id}/update', // 修改考题
    viewtopic: Config.service.api + '/knowledge/question/bank/{id}', // 查看考题
    deletetopic: Config.service.api + '/knowledge/question/bank/{id}/delete', // 删除考题
    code: Config.service.api + '/company/position/{id}/code', // 获取考试二维码
    answerList: Config.service.api + '/position/test/record/queryCompanyTestCount', // 获取答题列表
    startanswer: Config.service.api + '/position/test/record/open', // 开始答题
    getquestionList: Config.service.api + '/position/test/record/open/getQuestions', // 获取20道随机题
    // startanswer: Config.service.api + '/code', // 开始答题
    knowledgeDifficulty: Config.service.api + '/knowledge/point/difficulty', // 难度
    positiondetail: Config.service.api + '/open/company/position/{id}', // 答题岗位详情
    testdetail: Config.service.api + '/position/test/record/{id}', // 答题试卷详情
    openexamPositionSubmit: Config.service.api + '/user/position/exam/open/end/{id}', // 岗位测试提交
    inviteStatus: Config.service.api + '/student/expected/position/invite/status', // 企业邀请学生状态
    courseStatistics: Config.service.api + '/company/course/statistics', // 企业课程统计
    register: Config.service.api + '/company/companyUer/open/register', // 注册
    positionApplicant: Config.service.api + '/company/position/applicant/{id}/{id}', // 改变求职者申请岗位状态 0 id 1 status
    create: Config.service.api + '/company/position', // 新增岗位 POST
    firstUpdate: Config.service.api + '/company/position/{id}/first', // 新增岗位 PUT 修改岗位-第一步
    news: Config.service.api + '/company/info/{id}',
    tradeClass: Config.service.api + '/open/company/info/tradeclass', // 获取行业分类
    tradelist: Config.service.api + '/open/company/info/tradelist', // 获取分类对应行业领域 get id
    // getTree: Config.service.api + '/company/position/treepoint', // professionId
    saveTree: Config.service.api + '/company/position/{id}/savetree', //  第二步保存树 :id/saveTree POST
    // saveFilter: Config.service.api + '/company/position/{id}/filter', // 第三步保存筛选条件 :id/filter POST
    getTree: Config.service.api + '/company/position/treepoint', // professionId 新增岗位-第三步1获取职业通用树的技能点
    getTreeInfo: Config.service.api + '/company/position/info', // 技能点详情
    saveFilter: Config.service.api + '/company/position/{id}/filter', // 新增/修改岗位-第二步 添加限制 :id/filter PUT
    getPositionList: Config.service.api + '/company/position/my', // 获取企业自己的岗位列表
    getDetail: Config.service.api + '/company/position/{id}', // 获取岗位详情
    getInfo: Config.service.api + '/company/info/detail', //  企业认证信息
    companyList: Config.service.api + '/open/company/info', // 企业列表
    companyStudentAgreement: Config.service.api + '/company/studentagreement', // 企业定培协议列表
    companyStudentAgreementDetail: Config.service.api + '/company/studentagreement/{id}', // 企业定培协议详情
    companyStudentagreementPdf: Config.service.api + '/company/studentagreement/pdf/file/{id}', // 重新生成企业协议pdf
    publishPosition: Config.service.api + '/company/position/{id}/publish', // 发布岗位
    closePosition: Config.service.api + '/company/position/{id}/down', // 下架岗位
    positionTree: Config.service.api + '/company/position/{id}/tree', // 新增岗位-第三步2 修改/创建树 put/post
    companyStatus: Config.service.api + '/company/info/status', // 企业注册认证状态
    getOcr: Config.service.api + '/ocr/bizLicense', // 企业营业执照识别
    createLicense: Config.service.api + '/company/business/license/authentication', // 注册企业认证 认证信息修改
    license: Config.service.api + '/company/business/license', // 企业认证信息详情
    updateInfo: Config.service.api + '/company/info', // 修改企业基本信息
    updateProject: Config.service.api + '/company/info/project', // 修改企业产品
    updateDevelop: Config.service.api + '/company/info/develop', // 修改企业发展历程
    updateNews: Config.service.api + '/company/info/news', // 修改企业行业报道
    createPositionTest: Config.service.api + '/company/position/{id}/test', // 发布岗位测试
    studentsApplicant: Config.service.api + '/company/position/applicant', // 定制岗位-申请列表
    inviteSign: Config.service.api + '/student/expected/position/{id}/invite', // 发送邀请
    secondPostTest: Config.service.api + '/company/position/{id}/cancreatetree', // 查看第二步的其他要求是否已经提交
    companyCourse: Config.service.api + '/company/course', // 企业课程列表
    companyCourseUpdate: Config.service.api + '/company/course/{id}', // 企业课程列表
    companyCourseDetail: Config.service.api + '/company/course/me/{id}', // 企业课程详情/下架
    companyCourseOn: Config.service.api + '/company/course/on/{id}', // 课程上架
    companyCourseOff: Config.service.api + '/company/course/off/{id}', // 课程下架
    companyParams: Config.service.api + '/company/info/position/param', // 企业标签列表
    companyInviteStatus: Config.service.api + '/student/expected/position/{id}/invite/status', // 企业是否邀约过学生
    companyTtaff: Config.service.api + '/company/employee', // 企业员工列表
    companyTtaffDetail: Config.service.api + '/company/employee/{id}', // 企业员工详情
    companyCheckPhone: Config.service.api + '/company/employee/check/phone', // 新增验证手机号
    companyTtaffSendEmail: Config.service.api + '/company/employee/{id}/email', // 企业员工-发送通知邮件
    companyToken: Config.service.api + '/open/company/employee/register/token/check', // 企业员工-根据token获取注册信息
    companyRegister: Config.service.api + '/open/company/employee/register', // 企业员工-注册
    companyType: Config.service.api + '/company/employee/{id}/type/{id}', // 企业员工-角色类型变更
    companyDimission: Config.service.api + '/company/employee/{id}/dimission', // 企业员工-离职
    testChannel: Config.service.api + '/position/list', // 考题通道管理
    testTrueOrFalse: Config.service.api + '/position/{id}', // 开启或关闭考试通道
    AllTestTrueOrFalse: Config.service.api + '/position/batch', // 一键关闭考试通道
    jobSeekerList: Config.service.api + '/position/test/record/list', // 求职者列表
    jobSeekerDetail: Config.service.api + '/position/test/record/detail/{id}', // 求职者详情
    freeze: Config.service.api + '/knowledge/question/bank/wait', // 冻结/解冻自定义题库
    companyPositionDetail: Config.service.api + '/position/positiondetail/{id}', // 该岗位所需要的技能点
    updatePoint: Config.service.api + '/company/position/updatePoint', // 修改测试关联技能点
    knowledgePoint: Config.service.api + '/knowledge/point', // 修改测试关联技能点
    addToCustom: Config.service.api + '/knowledge/question/bank/batch/addToCustom', // 批量添加官方题库和企业题库到测试题
    addToOneCustom: Config.service.api + '/knowledge/question/bank/addToCustom', // 单个添加官方题库和企业题库到测试题
    deleteAll: Config.service.api + '/knowledge/question/bank/batch/delete', // 批量删除官方题库到自定义题库
    deleteOne: Config.service.api + '/knowledge/question/bank/delete', // 单个删除官方题库到自定义题库
    deleteQuestion: Config.service.api + '/company/position/{id}/testQuestion', // 当前测试题
    restoreKnowledge: Config.service.api + '/knowledge/question/bank/recycle', // 已删除题库单个还原到自定义题库
    restoreAllKnowledge: Config.service.api + '/knowledge/question/bank/batch/recycle', // 已删除题库批量还原到自定义题库
    questionBankSearch: Config.service.api + '/company/position/{id}/queryQuestionBank', // 岗位中题库搜索
    companyPositionList: Config.service.api + '/company/position/findProfession', // 公司发布的职位列表
    updateEmployee: Config.service.api + '/company/employee/{id}/updateEmployee', // 普通员工修改成为面试官
    professionIds: Config.service.api + '/company/employee/interviewer/professionIds', // 面试官对应职位
    professionquality: Config.service.api + '/company/professionquality' // 素质点列表
  },
  anchor: {
    anchorStatus: Config.service.api + '/anchor/info/status', // 主播注册认证状态
    courseStatistics: Config.service.api + '/anchor/course/statistics', // 主播课程统计
    promotion: Config.service.api + '/anchor/info', // POST 升级成为主播
    register: '/info/open/register', // 注册
    info: Config.service.api + '/anchor/info/{id}', // 获取主播信息
    course: Config.service.api + '/anchor/course', // 已发布课程列表
    infoBind: Config.service.api + '/anchor/info/bind', // 主播绑定银行账户
    modifyCourse: Config.service.api + '/anchor/course/{id}', // 已发布课程列表
    recycle: Config.service.api + '/anchor/course/on/{id}', // 重新上架
    soldOut: Config.service.api + '/anchor/course/off/{id}', // 下架
    order: Config.service.api + '/anchor/info/order', // 售卖信息
    evaluation: Config.service.api + '/anchor/info/appraise', // 评价记录
    update: Config.service.api + '/anchor/info', // 修改个人信息
    myInfo: Config.service.api + '/anchor/info/me', // 主播个人信息
    statistics: Config.service.api + '/anchor/info/appraise/statistics', // 课程评价统计
    balance: Config.service.api + '/user/balance/me', // 我的余额
    profitList: Config.service.api + '/user/balance/log/me' // 我的收支记录
  },
  course: {
    vodCallback: Config.service.api + '/open/vod/callback', // 课程转码回调
    courseList: Config.service.api + '/open/anchor/course', // 课程列表
    courseDetail: Config.service.api + '/open/anchor/course/{id}', // 课程详情
    chapterDetail: Config.service.api + '/anchor/course/chapter/{id}', // 章节详情
    relevantCourse: Config.service.api + '/open/anchor/course/{id}/relevantCourse', // 相关课程
    studentTrends: Config.service.api + '/open/anchor/course/{id}/studentTrends', // 求职者动态
    buyCourse: Config.service.api + '/student/course', // 我购买的课程列表
    courseAppraise: Config.service.api + '/anchor/course/{id}/appraise' // 课程评价
  },
  news: {
    class: Config.service.api + '/open/news/info/class', // 新闻分类
    list: Config.service.api + '/open/news/info', // 新闻列表
    detail: Config.service.api + '/open/news/info/{id}' // 新闻详情
  },
  university: {
    info: Config.service.api + '/university/{id}', // 学校信息
    update: Config.service.api + '/university/{id}', // 修改学校信息
    getJson: Config.service.api + '/university/tree', // 请求学校专业院系数据
    teacher: Config.service.api + '/open/university/teacher', // 老师列表
    student: Config.service.api + '/open/university/student', // 学生列表
    createDepartment: Config.service.api + '/university/department/', // 创建院系
    updateDepartment: Config.service.api + '/university/department/', // 修改院系
    deleteDepartment: Config.service.api + '/university/department/{id}', // 删除院系
    createMajor: Config.service.api + '/university/major/', // 新增专业
    updateMajor: Config.service.api + '/university/major/', // 修改专业
    deleteMajor: Config.service.api + '/university/major/{id}', // 删除专业
    signedStudent: Config.service.api + '/university/info/signed', // 签约学生
    allStudent: Config.service.api + '/university/info/all', // 全部学生
    employedStudent: Config.service.api + '/university/info/employed' // 入职学生

  },
  discussion: {
    list: Config.service.api + '/student/learning/discussion/discussion', // 问答列表
    detail: Config.service.api + '/student/learning/discussion/{id}', // 问答详情
    follow: Config.service.api + '/student/learning/discussionAnswer/{id}/follow', // 关注问题
    reply: Config.service.api + '/student/learning/discussionAnswer/{id}/reply', // 回复问题
    answer: Config.service.api + '/learning/discussion/answer', // 回答当前问题
    appraise: Config.service.api + '/appraise', // 发表评价
    discuss: Config.service.api + '/discuss' // 回复评价
  },
  open: {
    imageFormat: Config.service.api + '/open/company/info/formatImage',
    chinaarea: Config.service.api + '/open/sys/dict/chinaarea/selectedArea',
    activitystatus: Config.service.api + '/open/common/recharge/activity/status',
    studentValidate: Config.service.api + '/open/common/recharge/activity/signup/student/validate', // 学生身份验证
    rechargeOrder: Config.service.api + '/open/common/recharge/activity/order', // 活动充值
    recharge: Config.service.api + '/open/common/recharge/activity/{id}', // 优惠活动详情
    vodSignature: Config.service.api + '/vod/signature', // 获取视频上传签名
    universityList: Config.service.api + '/open/university', // 学校列表
    departmentList: Config.service.api + '/open/university/{id}/department', // 院系列表
    majorList: Config.service.api + '/open/university/{id}/major', // 专业列表
    classList: Config.service.api + '/open/university/{id}/class', // 专业列表
    professionList: Config.service.api + '/open/profession/info', // 职业列表
    majorCourse: Config.service.api + '/open/university/major/course', // 专业课程列表
    myMajorCourse: Config.service.api + '/university/major/course/me', // 我的专业课列表
    majorCourseId: Config.service.api + '/open/university/major/course/{id}', // 专业课程详情
    majorDetail: Config.service.api + '/open/university/major/{id}', // 专业详情
    majorProfessionList: Config.service.api + '/open/university/major/{id}/profession', // 专业下职业列表
    majorPositionList: Config.service.api + '/open/university/major/{id}/position', // 专业下岗位列表
    majorCourseVideo: Config.service.api + '/open/university/major/course/{id}/video', // 专业课程相关课程
    majorStudents: Config.service.api + '/open/university/major/{id}/students', // 签约学生
    sysFeedback: Config.service.api + '/sys/minifeedback', // 意见反馈
    getProvince: Config.service.api + '/open/sys/dict/chinaarea/province', // 获取中国省级行政区
    getCity: Config.service.api + '/open/sys/dict/chinaarea', // 获取省级行政区对应市级区划 level=2 code=xxx
    professionClassification: Config.service.api + '/open/profession/classification', // 职业分类
    // professionInfo: Config.service.api + '/open/student/profession/info', // 指定分类下职业列表 id
    getKnowledgeList: Config.service.api + '/open/student/knowledge/pointset/all', // 获取知识分类
    activeRank: Config.service.api + '/open/rank/active', // 活跃度排行
    growthRank: Config.service.api + '/open/rank/growth', // 成长度排行
    universityRank: Config.service.api + '/open/rank/university', // 学校排行
    statistics: Config.service.api + '/statistics/user', // 注册趋势
    employed: Config.service.api + '/statistics/employed', // 就业趋势
    getPointList: Config.service.api + '/open/student/knowledge/pointset/points', // setId 获取知识分类获取技能点
    getPositionDetial: Config.service.api + '/open/company/position/{id}', // id 获取某岗位对应详情
    informationList: Config.service.api + '/open/student/learning/material', //  课程资料列表
    informationdetail: Config.service.api + '/open/student/learning/material/{id}', //  课程资料详情
    getTagsList: Config.service.api + '/open/common/tagrepos', // 获取岗位标签列表
    getPositionList: Config.service.api + '/open/company/position', // 企业列表
    getPositionListHot: Config.service.api + '/open/company/position/hot', // 企业列表
    getJsonTree: Config.service.api + '/student/knowledge/tree/open/json', // 获取技能树json
    getApplyStudentList: Config.service.api + '/open/company/position/{id}/applystudent', // 获取某个岗位已申请的学生列表
    getOpenCompanyInfo: Config.service.api + '/open/company/info/{id}', // 获取某个企业的公开信息
    getToken: Config.service.api + '/open/general/token', // 获取七牛token
    message: Config.service.api + '/common/message/flow', // 求职者动态
    getDifficultyIdDetail: Config.service.api + '/open/student/knowledge/point/difficulty/{id}', // 通过知识点难度id获取相关技能点详情
    getDifficultyIdPositions: Config.service.api +
      '/open/student/knowledge/point/difficulty/{id}/position', // 通过知识点难度获取需要此知识点的岗位列表
    getLvKnowInfo: Config.service.api + '/open/student/knowledge/point/difficulty/other', // 根据难度值知识点id获取该知识点信息
    getDifficultyIdCourse: Config.service.api + '/open/anchor/course', // 获取关联某个知识点的课程
    getDifficultyIdRepository: Config.service.api + '/open/student/counselor', // 通过知识点获取知识库共享资料
    getDifficultyIdStudents: Config.service.api + '/open/student/knowledge/point', // 通过知识点难度获取学习学生列表
    personnelList: Config.service.api + '/open/student/expected/position', // 人才列表
    withdraw: Config.service.api + '/common/order/withdraw', // 提现
    withDraw: Config.service.api + '/common/order/apply/withdraw', // 提现(现在)
    TreeList: Config.service.api + '/student/open/knowledge/tree/commons', // 通用技能树列表
    binding: Config.service.api + '/open/wechat/login/binding/status', // 是否绑定微信
    qrcode: Config.service.api + '/open/wechat/login/qrcode', // 生成用户绑定微信二维码
    sendCode: Config.service.api + '/open/sms/wechat/unbinding/send', // 发送解绑验证码
    unbinding: Config.service.api + '/user/info/wechat/unbinding' // 解绑微信
  },
  employees: {
    check: Config.service.api + '/open/position/mate/phone', // 校验员工身份
    positionlist: Config.service.api + '/open/position/search', // 公司岗位
    startAnswer: Config.service.api + '/position/test/record/open', // 开始答题
    skills: Config.service.api + '/open/position/positiondetail/{id}', // 岗位技能点
    getQuestions: Config.service.api + '/position/test/record/open/getQuestions', // 考题列表
    examEnd: Config.service.api + '/user/position/exam/end/{id}', // 提交试卷
    result: Config.service.api + '/position/test/record/{id}' // 查看测试结果
  }
}
export default jsonurl



// WEBPACK FOOTER //
// ./src/common/config/api-url.js